import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

import { InstitutionsService } from './shared';

@Injectable({ providedIn: 'root' })
export class InstitutionContextResolver {
  private service = inject(InstitutionsService);

  resolve() {
    return this.service.context.pipe(take(1));
  }
}
